import {
  FacebookFilled,
  InstagramFilled,
  MailOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import {Typography} from 'antd';
import {Footer} from 'antd/es/layout/layout';
import PropTypes from 'prop-types';
import {Link, NavLink, useLocation, useNavigate} from 'react-router-dom';

import logo from '../../assets/logo.png';

const {Text} = Typography;

const FooterScreen = ({data = {}}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const socialLinks = [
    {
      name: 'Facebook',
      icon: <FacebookFilled />,
      url: 'https://www.facebook.com/share/17phNkRv4Q/',
    },
    {
      name: 'Instagram',
      icon: <InstagramFilled />,
      url: 'https://www.instagram.com/kalapistore.in?igsh=Y2t3MXl6bW5hZTdi',
    },
    {
      name: 'WhatsApp',
      icon: <WhatsAppOutlined />,
      url: 'https://wa.me/9125815116', 
    },
    {
      name: 'Email',
      icon: <MailOutlined />,
      url: 'mailto:contact@kalapi.store',
    },
  ];

  const footerSections = [
    {
      title: 'Company',
      links: [
        {label: 'About', path: '/about'},
        {label: 'Brand Center', path: '/brand-center'},
        {label: 'Business Card', external: true, path: '/businesscard'},
      ],
    },
    {
      title: 'Help Center',
      links: [
        {label: 'Contact', path: '/contact'},
        {label: 'Help', path: '/help'},
      ],
    },
    {
      title: 'Legal',
      links: [
        {label: 'Privacy Policy', path: '/privacy'},
        {label: 'Terms & Conditions', path: '/terms'},
      ],
    },
  ];

  return (
    <Footer className={'bg-white shadow-[0_-4px_12px_rgba(0,0,0,0.08)] z-10 md:px-20 px-4'}>
      <div className={'max-w-7xl mx-auto'}>
        {/* Top Section */}
        <div className={'flex flex-col md:flex-row gap-10'}>
          {/* Left Section */}
          <div className={'md:w-5/12'}>
            <NavLink to={'/'}>
              <img src={logo} alt={'Logo'} className={'h-[60px] mb-4'} />
            </NavLink>

            <p className={'text-primary-950 text-sm md:pr-36'}>
              Committed to quality and reliability. Built to serve with trust and
              integrity. Your satisfaction is our priority.
            </p>

            {/* Social Icons */}
            <div className={'flex gap-4 mt-4'}>
              {socialLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target={'_blank'}
                  rel={'noreferrer'}
                  className={'text-xl md:text-2xl text-primary-950 hover:text-primary-800 transition'}
                  aria-label={item.name}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Right Section */}
          <div className={'md:w-7/12 w-full grid grid-cols-3 md:grid-cols-3 gap-6'}>
            {footerSections.map(section => (
              <div key={section.title}>
                <h3 className={'text-lg font-bold text-primary-950 mb-3'}>
                  {section.title}
                </h3>

                <div className={'flex flex-col gap-2 text-primary-050'}>
                  {section.links.map(link =>
                    link.external ? (
                      <a
                        key={link.label}
                        href={link.path}
                        target={'_blank'}
                        rel={'noreferrer'}
                        className={'hover:underline'}
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        key={link.label}
                        to={link.path}
                        className={'hover:underline'}
                      >
                        {link.label}
                      </Link>
                    ),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className={'border-t border-primary-50 mt-6 pt-6 gap-2 text-center flex md:flex-row flex-col justify-between'}>
          <Text className={'text-sm text-primary-950'}>
            © {new Date().getFullYear()}{' '}
              Kalapi Store
            . All Rights Reserved.
          </Text>
          <Text className={'text-sm text-primary-950'}>
           Powered By - Ascensify Technology Kolhapur
          </Text>
        </div>
      </div>
    </Footer>
  );
};

FooterScreen.propTypes = {
  data: PropTypes.shape({
    facebookLink: PropTypes.string,
    instagramLink: PropTypes.string,
    whatsappLink: PropTypes.string,
    phone_no: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default FooterScreen;
